import React, { Component } from 'react'
import Select from '../forms/redux-select'
import { Button } from '../../components/buttons'
import Tooltip from 'rc-tooltip'
import 'rc-tooltip/assets/bootstrap.css'
import premiumAccess from '../../images/premium3.png'

const SubLocationNotificationForm = ({
  fields: { subLocationIds },
  subLocations,
  userType,

  error,
  submitting,
  handleSubmit
}) => {
  const isSupervisor = (userType === 'Supervisor')
  const premiumImg = isSupervisor ? (<img src={premiumAccess} className='premium notifications' alt='premiumAccess' width={18} height={18} />) : null
  return (
    <form onSubmit={handleSubmit}>
      <div>
        <Tooltip
          overlay={<span>Remove all Sub-locations to receive all notifications</span>}
          placement='left'>
          <h1>Sub-Location Notifications</h1>
        </Tooltip>
        <div className='settings-sub-locations'>
          <Select
            multi
            disabled={isSupervisor}
            options={subLocations}
            {...subLocationIds}
          />
          {premiumImg}
          <button type='submit'>Save</button>
        </div>
      </div>
    </form>
  )
}

export default SubLocationNotificationForm



// WEBPACK FOOTER //
// ./src/components/settings/sub-location-notification-form.js